import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectDestructuringEmpty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var merge = require('lodash/fp/merge');

import { User } from '@heimdall/core-domain';
import { logging } from '@heimdall/core-common';
import { getUserData } from '../accessors';
export function generate(firestore) {
  var logger = logging.instantiateLogger('heimdall:app:user:resolvers:query');
  var userDataRequestor = getUserData(firestore);
  return {
    getUserData: function () {
      var _getUserData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(_, _ref, _ref2) {
        var uid, log, request, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                uid = _ref.uid;

                _objectDestructuringEmpty(_ref2);

                log = logger.extend('getOrganizationData');
                log("Getting User Data for UID: ".concat(uid));
                _context.prev = 4;
                _context.next = 7;
                return userDataRequestor(uid);

              case 7:
                request = _context.sent;
                data = request.fold(function (err) {
                  log(err);
                  throw err;
                }, function (r) {
                  return r;
                });
                return _context.abrupt("return", merge(data, {
                  __typename: User.User.name
                }));

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](4);
                throw _context.t0;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 12]]);
      }));

      function getUserData(_x, _x2, _x3) {
        return _getUserData.apply(this, arguments);
      }

      return getUserData;
    }()
  };
}